export default context => {
    const moduleId = context.getters.moduleId;
    const notAnon = !context.rootGetters['appState/isAnonymous'];

    const elements = [
        `${moduleId}_complaint-submission_first-name`,
        `${moduleId}_complaint-submission_last-name`,
        `${moduleId}_complaint-submission_language`,
        `${moduleId}_complaint-submission_phone`,
        `${moduleId}_complaint-submission_email`,
        `${moduleId}_complaint-submission_address`,
    ];

    if (notAnon) {
        context.commit(`${moduleId}/ADD_TRACKED_ERRORS`, elements, { root: true });

    } else {
        context.commit(`${moduleId}/REMOVE_TRACKED_ERRORS`, elements, { root: true });
    }

    const setAttribute = function(context, id, attribute, value) {
        context.commit('setAttribute', {
            id,
            attribute,
            value,
        }, {
            root: true,
        });
    };

    setAttribute(context, `${moduleId}_complaint-submission_collapse`, 'visible', notAnon);

    setAttribute(context, `${moduleId}_complaint-submission_first-name`, 'required', notAnon);
    setAttribute(context, `${moduleId}_complaint-submission_last-name`, 'required', notAnon);
    setAttribute(context, `${moduleId}_complaint-submission_language`, 'required', notAnon);
    setAttribute(context, `${moduleId}_complaint-submission_phone`, 'required', notAnon);
    setAttribute(context, `${moduleId}_complaint-submission_email`, 'required', notAnon);
    setAttribute(context, `${moduleId}_complaint-submission_address`, 'required', notAnon);

    if (!notAnon) {
        setTimeout(() => {
            setAttribute(context, `${moduleId}_complaint-submission_first-name`, 'value', '');
            setAttribute(context, `${moduleId}_complaint-submission_last-name`, 'value', '');
            setAttribute(context, `${moduleId}_complaint-submission_language`, 'value', '');
            setAttribute(context, `${moduleId}_complaint-submission_phone`, 'phoneNumber', '');
            setAttribute(context, `${moduleId}_complaint-submission_email`, 'value', '');
            setAttribute(context, `${moduleId}_complaint-submission_address`, 'address1', '');
            setAttribute(context, `${moduleId}_complaint-submission_address`, 'address2', '');
            setAttribute(context, `${moduleId}_complaint-submission_address`, 'city', '');
            setAttribute(context, `${moduleId}_complaint-submission_address`, 'state', '');
            setAttribute(context, `${moduleId}_complaint-submission_address`, 'zip', '');
            setAttribute(context, `${moduleId}_complaint-submission_address`, 'county', '');

            context.dispatch('syncStore');
        });
    }
};